<!-- eslint-disable -->
<template lang="pug">
    .interactive-place
        .interactive-place__font-size-scaling-bar
            input.scaling-bar.cr-slider(
                type='range',
                @change="resizeText($event)",
                step='1', :min='minFontSize', :max='maxFontSize',
                :value='fontSize'
            )
            .scale-text-info {{ $i18n.t('trainer.trainer_game_shutter_scale', {element: scaleElement}) }}
        .interactive-place__buttons(v-if="!isGameTuned")
            cs-button(
                color="green"
                pattern="primary-outline"
                @click="$emit('doneWithPreparing')"
            ) {{ $i18n.t('common.common_button_done') }}
        .interactive-place__overflow-container(:class="{'interactive-place__overflow-container_without-overflow': amountOfWords === 1}")
            .interactive-place__test-text(
                v-if="!isGameTuned"
                :class="{'inverted-word': invertedItem && !isItemColumnMode}"
                :style="{ fontSize: minFontSize + 'px'}"
            )
                .test-text__row(
                    :class="rowsName"
                    v-for="word in displayedTestLines"
                    ref="wordLine"
                )
                    span(:class="{'inverted-word': invertedItem && isItemColumnMode}") {{ word }}
</template>

<script>
    /*eslint-disable*/
    import textScrollMixin from '../../../../utils/trainer/textScroll';

    const LINE = "Проверка. ";
    const LINE_REPETITIONS_NUMBER = 20;

    export default {
        props: {
            elementName: String,
            isGameTuned: Boolean,
            isFromShutter: {
                type: Boolean,
                default: false,
            },
            invertedItem: {
                type: Boolean,
                default: false,
            },
            isItemColumnMode: {
                type: Boolean,
                default: false,
            },
            amountOfWords: {
                type: Number,
                default: 10,
            },
            rowsName: String,
            fontSize: [Number, String],
            scaleElement: {
                type: String,
                default () {
                    return this.$i18n.tc('trainer.trainer_gamePlayBox_words');
                }
            },
            isAnagrams: {
                type: Boolean,
                default: false
            },
            isAnagramsWithTime: {
                type: Boolean,
                default: false
            },
            isMobilePhone: {
                type: Boolean,
                default: false,
            },
            isCatchWord: {
                type: Boolean,
                default: false,
            }
        },
        mixins: [textScrollMixin],
        created () {
            document.addEventListener("keydown", this.doneOnEnter);
        },
        mounted () {
            this.gameBoxName = 'interactive-place__test-text';
            this.$emit('setFontSize', this.minFontSize);
        },
        methods: {
            resizeText (event) {
                let fontSize = event.target.value;
                this.element.style.fontSize = fontSize + 'px';
                this.element.style.lineHeight = (+fontSize + 13) + 'px';
                this.$emit('setFontSize', fontSize);
                if (this.isFromShutter) {
                    let height, width;
                    [height, width] = !this.isGameTuned ? [this.$refs.wordLine[0].clientHeight, this.$refs.wordLine[0].clientWidth] : [0, 0];
                    this.$emit('setHeight', height, width);
                }
            },
            doneOnEnter (event) {
                if (event.keyCode === 13) {
                    document.removeEventListener('keydown', this.doneOnEnter);
                    this.$emit('doneWithPreparing')
                }
            },
        },
        computed: {
            element () {
                if (this.isGameTuned) {
                    return document.querySelector(`.${this.elementName}`);
                }
                return document.querySelector('.interactive-place__test-text');
            },
            displayedTestLines () {
                if (!this.isGameTuned) {
                    let line_number = this.isItemColumnMode ? this.amountOfWords : LINE_REPETITIONS_NUMBER;
                    let text = LINE.repeat(line_number);
                    let displayedLines = [];
                    if (this.isItemColumnMode) {
                        displayedLines = _.take(text.match(/[^.!?]+[.!?"'»]+/g), this.amountOfWords);
                    } else {
                        displayedLines = _.chunk(text.split(" "), this.amountOfWords);
                        displayedLines = _.map(displayedLines, arr => arr.join(' '));
                    }
                    return displayedLines;
                }
                return [];
            },
            minFontSize () {
                const WindowWidth = document.documentElement.clientWidth;
                if (this.isCatchWord) {
                    if (WindowWidth < 576) {
                        return 26;
                    } else if (WindowWidth < 768) {
                        return 32;
                    } else if (WindowWidth < 1200) {
                        return 42;
                    }
                    return 82;
                }
                return 20;
            },
            maxFontSize () {
                const WindowWidth = document.documentElement.clientWidth;
                if (this.isCatchWord) {
                    if (WindowWidth < 576) {
                        return 52;
                    } else if (WindowWidth < 768) {
                        return 70;
                    } else if (WindowWidth < 1200) {
                        return 96;
                    } else if (WindowWidth < 1440) {
                        return 164;
                    } else if (WindowWidth < 1920) {
                        return 202;
                    }
                    return 242;
                }
                if (WindowWidth < 576) {
                    return 40;
                } else if (WindowWidth < 768) {
                    return 62;
                } else if (WindowWidth < 1200) {
                    return 76;
                } else if (WindowWidth < 1440) {
                    return 100;
                }
                return 90;
            }
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.doneOnEnter)
        },
    }
</script>

<style lang="scss" scoped>
    .scale-text-info {
        font-size: 18px;
        line-height: 21px;
        white-space: normal;
        margin-top: 10px;
    }

    .scaling-bar {
        -webkit-appearance: none;
        width: 100%;
        background: transparent;
        &:focus {
            outline: none;
        }
        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            height: 16px;
            width: 16px;
            border-radius: $border-radius-circle;
            background: $hsl-color-green-58;
            margin-top: -6px;
            cursor: pointer;
        }
        &::-moz-range-thumb {
            -webkit-appearance: none;
            height: 16px;
            width: 16px;
            border-radius: $border-radius-circle;
            background: $hsl-color-green-58;
            cursor: pointer;
        }
        &::-ms-thumb {
            -webkit-appearance: none;
            height: 16px;
            width: 16px;
            border-radius: $border-radius-circle;
            background: $hsl-color-green-58;
            cursor: pointer;
        }
        &::-webkit-slider-runnable-track {
            width: 100%;
            height: 6px;
            cursor: pointer;
            background: $hsl-color-gray-92;
            border-radius: $border-radius-40;
        }
    }

    .interactive-place {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        max-height: 100%;
    }

    .interactive-place__font-size-scaling-bar {
        text-align: center;
        margin-bottom: 30px;
        max-width: 260px;
    }

    .interactive-place__overflow-container {
        overflow-y: auto;
        height: 100%;
        @include scrollbar;
    }

    .interactive-place__overflow-container_without-overflow {
        overflow-y: initial;
    }

    .interactive-place__test-text {
        padding: 0 20px;
        text-align: center;
        font-size: 20px;
        user-select: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        flex-direction: column;
    }

    .interactive-place__buttons {
        margin-bottom: 30px;
        text-align: center;
    }

    .inverted-word {
        display: inline-block;
        transform: rotate(180deg);
    }
</style>

